import type {Model, ModelInputSchema, PlaygroundMessage} from '../../types'

// There is no guarantee that new models will accept image requests in the same format, so this array includes only
// the model families that we have accounted for so far.
const SUPPORTED_IMAGE_FAMILIES = ['Microsoft', 'OpenAI', 'Meta']

export const supportInputAttachments = (catalogData: Model) => {
  return (
    SUPPORTED_IMAGE_FAMILIES.includes(catalogData.model_family) &&
    catalogData.supported_input_modalities.includes('image')
  )
}

export const reachedMaxAttachments = (messages: PlaygroundMessage[], modelInputSchema: ModelInputSchema) => {
  const hasImageLimits = modelInputSchema?.capabilities?.chat?.messagesWithImages
  const imageCount = messages.filter(
    message => Array.isArray(message.message) && message.message.filter(m => m.type === 'image_url'),
  ).length
  return hasImageLimits ? imageCount >= hasImageLimits : false
}
